// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)

import { RequestState }                  from '@core/interfaces/api.interface';
import { ICashPointClosingEntityEvents } from '@core/interfaces/entity.interface';

export class CashPointClosingTMO {
	id?: string = undefined;
	importId?: string = undefined;
	ersId?: string = undefined;
	ersIdentifier?: string = undefined;
	ersSerialNumber?: string = undefined;
	closingNumber?: string = undefined;
	businessDate?: Date = undefined;
	created?: Date = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class CashPointClosing extends CashPointClosingTMO {
	etag?: string = undefined;

	public ui?: ICashPointClosingEntityEvents = {
		requestState: RequestState.NOT_ASKED,
		requestError: undefined,
		entityActions: {}
	};
}

// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************


// ENUMS #############################################################
// API enums *********************************************************
// UI enums *********************************************************
